import React from "react";
import { Alert } from "@mui/material";

const NoteSaveHint = ({ children }) => (
  <Alert severity="info" className="view-pdf__notes-footer__hint">
    {children}
  </Alert>
);

export default NoteSaveHint;
